import React from 'react';
import { Button } from './ui/Button';
import { MicIcon, ZapIcon } from 'lucide-react';
export function Hero() {
  return <section className="relative w-full py-20 md:py-32 px-6 md:px-10 lg:px-20 overflow-hidden" data-id="element-130">
      {/* Background gradient effect */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#111] via-[#111] to-[#3F00FF]/20 z-0" data-id="element-131"></div>
      {/* Animated waveform background */}
      <div className="absolute inset-0 opacity-10 z-0 flex items-center justify-center" data-id="element-132">
        <div className="w-full h-64 text-[#00E0FF]" data-id="element-133" />
      </div>
      <div className="relative z-10 max-w-4xl mx-auto text-center" data-id="element-134">
        <div className="inline-block mb-4 px-4 py-1 rounded-full bg-[#3F00FF]/20 border border-[#00E0FF]/30" data-id="element-135">
          <span className="text-[#00E0FF] text-sm font-medium flex items-center" data-id="element-136">
            <ZapIcon className="w-4 h-4 mr-2" data-id="element-137" />
            CRITICAL VOICE
          </span>
        </div>
        <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold mb-6 leading-tight" data-id="element-138">
          The World's Most Advanced <br data-id="element-139" />
          <span className="text-[#00E0FF]" data-id="element-140">Real-Time Voice AI</span>
        </h1>
        <p className="text-xl md:text-2xl text-gray-300 mb-10 max-w-3xl mx-auto" data-id="element-141">
          Why type when you can talk? Why talk to a robot when you can speak to
          AI that sounds… human?
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-142">
          <a href="https://ai-therapist-production.up.railway.app/" target="_blank" rel="noopener noreferrer" data-id="element-143">
            <Button size="large" data-id="element-144">
              <MicIcon className="w-5 h-5 mr-2" data-id="element-145" />
              Try Voice Demo
            </Button>
          </a>
          <a href="https://ai-therapist-production.up.railway.app/" target="_blank" rel="noopener noreferrer" data-id="element-146">
            <Button variant="outline" size="large" data-id="element-147">
              Get API Access
            </Button>
          </a>
        </div>
      </div>
    </section>;
}